import React, {useMemo} from "react";

import {useUser} from "~/api/hooks/useUser";
import {getContrastColor} from "~/util/color";

interface UserNameProps {
  userId?: string;
  showFullOnHover?: boolean;
}

const UserName: React.FC<UserNameProps> = React.memo(
  ({userId, showFullOnHover = true}) => {
    const userKey = useMemo(() => ({id: userId}), [userId]);
    const {data} = useUser(userKey);

    // Special case for system user
    if (userId === "system") {
      return (
        <div>
          <span
            className={`truncate p-1 rounded-full`}
            style={{
              color: "white",
              backgroundColor: "black",
            }}
          >
            System
          </span>
        </div>
      );
    }

    const titleAttr = showFullOnHover && data?.name ? {title: data.name} : {};

    // Determine background color based on text color for better contrast
    const backgroundColor = getContrastColor(data?.color);

    return (
      <div>
        <span
          className={`truncate p-1 rounded-full`}
          style={{
            color: data?.color,
            backgroundColor,
          }}
          {...titleAttr}
        >
          {data?.name ?? "loading..."}
        </span>
      </div>
    );
  },
);

export default UserName;
